import React, { useState, useEffect } from "react";
import { IonGrid, IonRow, IonCol, IonLabel, IonDatetime } from "@ionic/react";
import { getYearValues } from "../../../utils/formatData";
import { useTranslation } from "react-i18next";

const PickUpTimeComponent: React.FC<any> = (props: any) => {
  const { 
    fromDate, 
    toDate, 
    pickUpLocalTime, 
    handleError,
    disable = false,
    errorMessage = 'PickUpdateError',
    label ='Pick-up Date',
    errorMessage2,
   } = props;
  const [showError, setShowError] = useState(false);
  const handleChange = (event: any) => {
    props.handleChange(event);
  };
  const consecYears = getYearValues() || new Date().getFullYear();
  const { t } = useTranslation();
  
  useEffect(() => {
    if (disable && showError) {
      setShowError(false);
      handleError(false);
    } else {
      if (fromDate && toDate) {
        const value = toDate.split("T")[0] < fromDate.split("T")[0];
        setShowError(value || props.error);
        handleError(value);
      }
    }
  }, [fromDate, toDate,props.error, disable]);

  return (
    <>
      <IonGrid class="time-window" data-testid="PickUpTimeComponent">
        <IonRow class="pickuptime-title">{t(label)}</IonRow>
        <IonRow>
          <IonCol>
            <IonLabel class="pickup-date-title">{t('From Date')}</IonLabel>
            <IonDatetime
              displayFormat="MMM DD, YYYY"
              min={getPickupLocalTimeSplit(pickUpLocalTime)}
              value={fromDate?.split("T")[0]}
              yearValues={consecYears}
              onIonChange={(event) => handleChange(event)}
              mode="ios"
              name="fromDate"
              disabled = {disable}
            ></IonDatetime>
          </IonCol>
          <IonCol>
            <IonGrid class="to-date-grid">
              <IonLabel class="pickup-date-title">{t('To Date')}</IonLabel>
              <IonDatetime
                displayFormat="MMM DD, YYYY"
                min={getPickupLocalTimeSplit(pickUpLocalTime)}
                value={toDate?.split("T")[0]}
                yearValues={consecYears}
                onIonChange={(event) => handleChange(event)}
                mode="ios"
                name="toDate"
                disabled = {disable}
              ></IonDatetime>
            </IonGrid>
          </IonCol>
        </IonRow>
      </IonGrid>
      {showError ? (
        <IonGrid className="pickupdate-error">
          {errorMessage && <p>{t(errorMessage)}</p>}
          {errorMessage2 && <p>{t(errorMessage2)}</p>}
        </IonGrid>
      ) : null}
    </>
  );
};

const getPickupLocalTimeSplit = (pickUpLocalTime:any)=>{
return pickUpLocalTime?.split("T")[0];
}
export default React.memo(PickUpTimeComponent);
